import {AfterViewInit, Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'common-ui-fragebogen-senden',
    templateUrl: './fragebogen-senden.component.html',
    styleUrls: ['./fragebogen-senden.component.scss']
})
export class FragebogenSendenComponent implements OnInit, AfterViewInit {

    @ViewChild(ModalDirective) lgModal: ModalDirective;

    @Output()
    public sending: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    public canceling: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    hasAttachments: boolean;

    @Input()
    public context: string;

    @Input()
    public readonly = false;

    @Input()
    public set disabled(value: boolean | string) {
      this.isDisabled = value != null && `${value}` !== 'false';
    }

    @HostBinding('attr.disabled') isDisabled: boolean | null = null;

    constructor() {
    }

    public ngOnInit(): void {
    }

    public ngAfterViewInit(): void {
        if (this.lgModal?.config) {
            this.lgModal.config.ignoreBackdropClick = true;
        }
    }

    public onSending(): void {
      this.sending.emit();
    }

    public onCanceling(): void {
      // this.canceling.emit();
      this.lgModal.hide();
    }
}
